export const statsProgressColors = {
    gray: {
        base: 'var(--color-gray-700)',
        fill: 'var(--color-gray-500)',
    },
    info: {
        base: 'var(--color-info-100)',
        fill: 'var(--color-status-reviewed)',
    },
    success: {
        base: 'var(--color-success-100)',
        fill: 'var(--color-success-500)',
    },
} as const;

export const calculateStatsProgress = (count: number, total: number): number => {
    return total > 0 ? count / total : 0;
};
